import { render, staticRenderFns } from "./PurchasePrincipleIndex.vue?vue&type=template&id=ca3d8c60"
import script from "./PurchasePrincipleIndex.vue?vue&type=script&lang=js"
export * from "./PurchasePrincipleIndex.vue?vue&type=script&lang=js"
import style0 from "./PurchasePrincipleIndex.vue?vue&type=style&index=0&id=ca3d8c60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports